import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/components/i18n'
import './styles/element-variables.scss'

import './permission' // permission control


import directive from './directive' // directive
Vue.use(directive)

import mixin from '@/mixins';
Vue.mixin(mixin);

// 滑块验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);//滑块验证

import * as filters from './filters' // global filters
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import '@/styles/main.scss'

import vueComs from '@/components/index'  //注入
Vue.use(vueComs)

Vue.prototype.$imgPrefix = location.origin.includes('localhost') ? 'http://autofis.wms.auto-fis.com:3900/prod-api/file/img?filePath=' : '/prod-api/file/img?filePath=',

Vue.config.productionTip = false

import download from '@/utils/download'
import { objArrayCompare, flatTreeData, isImage } from '@/utils'
// 全局方法
Vue.prototype.$download = download
Vue.prototype.$objArrayCompare = objArrayCompare
Vue.prototype.$flatTreeData = flatTreeData
Vue.prototype.$isImage = isImage
Vue.prototype.$isProduction = true

// 在main.js中全局引入
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

import $ from 'jquery'
window.jQuery = $
window.$ = $

import { menuIds } from '@/utils/constants';
Vue.prototype.$menuIds = menuIds

Vue.use(VideoPlayer)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
